import { normalizeArabic } from "@/v2/utils";
import { layoutStyles, textStyles } from "../../common";
import { TD, TH } from "@ag-media/react-pdf-table";

export default function BlockHeading({
    arabicTitle,
    englishTitle,
}: {
    arabicTitle: string;
    englishTitle: string;
}) {
    return (
        <TH
            style={[
                layoutStyles.flexBetween,
                { fontWeight: 700, fontSize: "11px" },
            ]}
        >
            <TD
                style={{
                    color: "#4e3cc3",
                }}
            >
                {englishTitle}
            </TD>
            <TD
                style={[
                    {
                        color: "#4e3cc3",
                        justifyContent: "flex-start",
                    },
                    textStyles.arabicText,
                ]}
            >
                {normalizeArabic(arabicTitle)}
            </TD>
        </TH>
    );
}
